new Swiper(".categories-filters__slider", {
  slidesPerView: "auto",
  spaceBetween: 10,
});

$(document).on("click", ".categories-filters__show-more", function () {
  const $block = $(this).parents(".categories-filters__inner").first().find(".categories-filters__additional");

  $block.toggleClass("is--opened");
  $(this).toggleClass("is--opened");

  if ($block.hasClass("is--opened")) {
    $block.css({ height: `${$block.prop("scrollHeight") + 24}px` });
  } else {
    $block.css("height", "");
  }
});
